import { useTranslations } from "hooks";
import { useQuizStore } from "index";
import { useEffect, useState } from "react";
import { useTooltip } from "../hooks/useGetTooltip";

export const QuizChoice = ({txt, imgId, responseKey, index}: QuizChoiceType): JSX.Element => {
    const [TEXT] = useTranslations(i18n(responseKey))
    const content = useTooltip(txt || TEXT)
    const [img, setImg] = useState<string>()
    const {getQuizInfo} = useQuizStore()
    const [type, setType] = useState<choiceType>()

    useEffect(() => {
        if(content) {
            const item = content?.[0]?.toString()?.trim().toUpperCase()
            setType(getType(item))
        }
    }, [content])

    useEffect(() => {
        type && setImg(getImg(type))
    }, [type])
    
    const getImg = (type: choiceType) => {
       return type == 'OTHER' ? `picto-choice${index}` : `picto-${type?.toString().toLowerCase()}`
    } 

    const getType = (item: string) => {
        if(item) {
            if(YESLABEL.includes(item)) {
              return 'YES'
            } else if (NOLABEL.includes(item)) {
                return 'NO'
            }
          }
         return 'OTHER' 
    }
    return(
        <div className={`quizChoice quizChoice-${type?.toString().toLowerCase()}`}>
            <p className="quizChoice-txt">{content && [...content]}</p>
            { !index
                ? <img src={`/assets/img/common/${imgId}.png`} />
                :  <img src={`/assets/img/${getQuizInfo()?.name ? getQuizInfo()?.name : 'common'}/${imgId}.png`}
                onError={(e: Record<string, any>)=>{e.target.onerror = null; e.target.src=`/assets/img/${getQuizInfo()?.name ? getQuizInfo()?.name : 'common'}/${img}.png`}}/>

            }
        </div>
    )
}

type QuizChoiceType = {
    index?: number
    txt?: string
    imgId?: string
    responseKey?: string
}

type choiceType = 'YES' | 'NO' | 'OTHER' | undefined

const i18n = (key?: string) => [
    `MedicalDevice.${key}.text`
]

const YESLABEL = ["OUI", "YES"];
const NOLABEL = ["NON", "NO"];